/**
 * O'ZBEKISTON TELEFON RAQAMI — bitta shakl, bitta qoida.
 *
 * Tizimda boshqa mamlakat raqami yo'q va bo'lmaydi ham: bu temir yo'lning
 * ichki tizimi. Shuning uchun `+998` ni odam terib o'tirmaydi — u maydonda
 * TAYYOR turadi, xodim esa faqat o'zining 9 xonasini yozadi.
 *
 * Fayl SOF: brauzerga ham, React ga ham, bazaga ham qaramaydi. Shu sababli
 * bitta nusxadan uchala tomon foydalanadi — web forma, mobil kirish oynasi
 * va serverdagi tekshiruv. Ilgari har biri o'z tekshiruvini yozgan edi va
 * ular allaqachon bir-biridan farq qila boshlagandi.
 */
export const UZ_CALLING_CODE = '998';
/** Mamlakat kodisiz qism: operator kodi (2) + raqam (7). */
export const UZ_NATIONAL_LENGTH = 9;
/**
 * Yozilgan matndan MILLIY qismni ajratadi — ko'pi bilan 9 ta raqam.
 *
 * Mamlakat kodi faqat ORTIQCHA bo'lgandagina olib tashlanadi
 * (`length > 9`). Aynan shu shart muhim: `99 812-34-56` ham haqiqiy milliy
 * raqam (operator kodi `99`) va u ham `998` bilan boshlanadi. Shartsiz
 * kesib tashlansa, bunday raqam jimgina buzilardi.
 *
 * Takroriy `while` esa nusxa-ko'chirish uchun: odam `+998 +998 90...`
 * ko'rinishida ham joylashtirib yuboradi.
 */
export const uzNationalDigits = (raw) => {
    let digits = raw.replace(/\D/g, '');
    while (digits.length > UZ_NATIONAL_LENGTH && digits.startsWith(UZ_CALLING_CODE)) {
        digits = digits.slice(UZ_CALLING_CODE.length);
    }
    return digits.slice(0, UZ_NATIONAL_LENGTH);
};
/**
 * Milliy qismni `90 123-45-67` ko'rinishiga soladi.
 *
 * Yarim yozilgan raqam ham bo'ladi: ajratgichlar odam terib borgan sari
 * qo'shiladi, oldindan turmaydi. Bo'sh joyga `_ _ _` qo'yib kutib turgan
 * niqob kursorni o'sha belgilarga urib yuboradi va telefonda ayniqsa
 * bezovta qiladi.
 */
export const formatUzNational = (digits) => {
    const value = uzNationalDigits(digits);
    const head = value.slice(0, 2);
    const tail = [value.slice(2, 5), value.slice(5, 7), value.slice(7, 9)]
        .filter((part) => part !== '')
        .join('-');
    if (tail === '')
        return head;
    return `${head} ${tail}`;
};
/** Maydonda 9 xona TERIB BO'LINDIMI — forma tugmasini ochish uchun. */
export const isUzPhoneComplete = (raw) => uzNationalDigits(raw).length === UZ_NATIONAL_LENGTH;
/**
 * Yozilgan raqamning milliy qismi — faqat yozuv KUTILGAN shaklda bo'lsa.
 *
 * `uzNationalDigits` dan farqi qat'iylikda: u terilayotgan chala raqam
 * uchun, ya'ni ortiqchasini indamay kesib tashlaydi. Bu yerda esa
 * ortiqcha raqam — XATO: `+998 90 123-45-67 89` ni jimgina qisqartirish
 * bazaga boshqa odamning raqamini yozib qo'yishi mumkin.
 */
export const uzPhoneNational = (raw) => {
    const digits = raw.replace(/\D/g, '');
    if (digits.length === UZ_NATIONAL_LENGTH)
        return digits;
    if (digits.length === UZ_CALLING_CODE.length + UZ_NATIONAL_LENGTH &&
        digits.startsWith(UZ_CALLING_CODE)) {
        return digits.slice(UZ_CALLING_CODE.length);
    }
    return null;
};
/** Saqlashga yaroqli raqammi — server shu tekshiruvga tayanadi. */
export const isUzPhone = (raw) => uzPhoneNational(raw) !== null;
/**
 * SAQLASH shakli — `+998901234567`, oraliqsiz.
 *
 * Bazada YAGONA ko'rinish turadi, aks holda bir xil raqam ro'yxatda uch
 * xil yozuvda ko'rinardi. Chiroyli ajratgichlar ekranga chiqarishda
 * qo'shiladi (`formatUzPhone`) — ular ma'lumot emas, bezak.
 */
export const toUzPhone = (raw) => `+${UZ_CALLING_CODE}${uzPhoneNational(raw) ?? uzNationalDigits(raw)}`;
/**
 * KO'RSATISH shakli — `+998 90 123-45-67`.
 *
 * Matn kutilgan shaklda bo'lmasa (eski yozuv, boshqa mamlakat kodi, yarim
 * kiritilgan raqam) u O'ZGARMAY qaytadi. Bu ataylab: ko'rinishni
 * "tuzatib" yuborish bazada aslida nima turganini odamdan yashirardi —
 * u esa aynan shu xatoni topib tuzatishi kerak.
 */
export const formatUzPhone = (raw) => {
    const national = uzPhoneNational(raw);
    if (national === null)
        return raw;
    return `+${UZ_CALLING_CODE} ${formatUzNational(national)}`;
};
//# sourceMappingURL=phone.js.map